module.exports = __webpack_public_path__ + "img/right-arm_hover.861c775f.png";